module.exports = __webpack_public_path__ + "img/zhongsheng.bfacb3bb.png";